export default __webpack_public_path__ + "static/5-c7d14a7415374e22efce8ca63719569f.png";